import React from 'react';
import ReactDOM from 'react-dom';
import styles from './confirm.module.scss';

const Confirm = (props) => {
  return ReactDOM.createPortal(
    <>
      {props.show &&
        <div className={styles.mask}>
          <div className={props.isLight ? `${styles.confirm} ${styles.light}` : `${styles.confirm}`} id="confirm" style={props.style}>
            <div className={styles.confirmInner}>
              <img src={props.isLight ? require("../../../assets/img/confirm/caution_light@2x.png") : require("../../../assets/img/confirm/caution@2x.png")} alt="" />
              <div className={styles.content}>
                {props.content && <p>{props.content}</p>}
                {props.html && <p dangerouslySetInnerHTML={props.html} />}
              </div>
              <div className={styles.buttonGroup}>
                {props.confirm && <button className={styles.submit} onClick={() => props.confirm?.onConfirm()}>{props.confirm?.text}</button>}
                {props.cancel && <button className={styles.cancel} onClick={() => props.cancel?.onCancel()}>{props.cancel?.text}</button>}
              </div>
            </div>
          </div>
        </div>
      }
    </>,
    document.getElementById('knowledgePointPlayback') || document.body
  );
}

export default Confirm;
